import { av, avp } from "@adsk/lmv";

/**
 * Saving a view that has a filter (e.g. level) and manually hidden elements does not work out of the box with LMV.
 * This is how it worked in Tandem:
 *   - Apply filter -> isolates elements in the viewer, but does NOT store them in FacetsManager.isolated
 *   - Manually hide elements
 *     -> removes elements from the isolation list in the viewer (i.e. does NOT add them to the hidden list), but
 *        reports them as hidden via the AGGREGATE_HIDDEN_CHANGED_EVENT sent from the viewer
 *     -> adds them to FacetsManager.hidden
 * When saving the view
 *   -> store the filter, but not the list of isolated elements (would be redundant)
 *   -> store the list of hidden elements from FacetsManager.hidden
 *
 * In LMV, the visibility manager only reports elements that actually end up in the hidden list via the
 * AGGREGATE_HIDDEN_CHANGED_EVENT. Since they usually just get removed from the isolated list, we receive
 * an empty list with that event, and FacetsManager.hidden remains empty.
 * This patch makes sure to report hidden elements via the event if they are not sent by the viewer.
 */

const origAggregateHide = avp.MultiModelVisibilityManager.prototype.aggregateHide;

avp.MultiModelVisibilityManager.prototype.aggregateHide = function (nodes) {
  const listener = (event) => {
    this.viewerImpl.api.removeEventListener(av.AGGREGATE_HIDDEN_CHANGED_EVENT, listener);

    // event.hidden is the list of nodes that LMV's visibility manager actually lists as hidden.
    // Tandem expects the list of nodes that were requested to be hidden, so we replace the event payload.
    const hidden = nodes && nodes.length ?
    nodes.map(({ model, ids, selection }) => ({ model, ids: ids || selection })) :
    [];

    event.hidden = hidden;
  };

  this.viewerImpl.api.addEventListener(av.AGGREGATE_HIDDEN_CHANGED_EVENT, listener, { priority: Infinity });

  origAggregateHide.call(this, nodes);
};